export class UsuarioAerovale {
  nombreCompleto: string;
  userName: string;
  dni : string;
}
